import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './lib/queryClient';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import ProductionDetail from './pages/ProductionDetail';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import SongEdit from './pages/SongEdit';
import Superadmin from './pages/Superadmin';
import SessionExpiredDialog from './components/SessionExpiredDialog';
import SuperadminRoute from './components/SuperadminRoute';
import KontekstRoute from './components/KontekstRoute';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
            <Router>
            <SessionExpiredDialog />
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <KontekstRoute>
                    <Dashboard />
                  </KontekstRoute>
                </ProtectedRoute>
              }
            />
          <Route
            path="/produksjon/:id"
            element={
              <ProtectedRoute>
                <KontekstRoute>
                  <ProductionDetail />
                </KontekstRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <KontekstRoute>
                  <AdminRoute>
                    <Settings />
                  </AdminRoute>
                </KontekstRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/musikk/ny"
            element={
              <ProtectedRoute>
                <KontekstRoute>
                  <AdminRoute>
                    <SongEdit />
                  </AdminRoute>
                </KontekstRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/musikk/:id"
            element={
              <ProtectedRoute>
                <KontekstRoute>
                  <AdminRoute>
                    <SongEdit />
                  </AdminRoute>
                </KontekstRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin"
            element={
              <ProtectedRoute>
                <SuperadminRoute>
                  <Superadmin />
                </SuperadminRoute>
              </ProtectedRoute>
            }
          />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
      <Toaster />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;

